var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#3857C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36987 5.11994C6.20791 4.42396 6.6405 3.74469 7.33956 3.59661C8.45019 3.36135 10.1931 3.0708 12.0273 3.0708C13.8616 3.0708 15.6045 3.36135 16.7151 3.59661C17.4142 3.74469 17.8468 4.42396 17.6848 5.11994C17.6111 5.43681 17.5256 5.76461 17.4349 6.03564C17.2884 6.47336 17.045 7.04211 16.8389 7.49975C16.6179 7.9906 16.1257 8.29736 15.5874 8.29736H8.46725C7.92894 8.29736 7.43678 7.9906 7.21578 7.49975C7.00973 7.04211 6.76626 6.47336 6.6198 6.03564C6.52911 5.76461 6.44361 5.43681 6.36987 5.11994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0746 7.77127C10.8814 7.77127 10.7712 7.55056 10.8873 7.39608L11.841 6.1272C11.9347 6.00246 12.1219 6.00246 12.2157 6.1272L13.1694 7.39608C13.2855 7.55056 13.1753 7.77127 12.982 7.77127L12.0283 7.77127L11.0746 7.77127Z",
    fill: "#76D0BE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7925,
    y: 3.70361,
    width: 0.46875,
    height: 0.84375,
    rx: 0.234375,
    fill: "#0E2782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7056 4.83105C15.7509 4.75258 15.8512 4.72569 15.9297 4.771C16.0081 4.8163 16.035 4.91664 15.9897 4.99511L15.896 5.15749C15.8507 5.23596 15.7503 5.26285 15.6719 5.21754C15.5934 5.17224 15.5665 5.0719 15.6118 4.99343L15.7056 4.83105Z",
    fill: "#0E2782"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06445 4.99511C8.01915 4.91664 8.04603 4.8163 8.1245 4.771C8.20297 4.72569 8.30331 4.75258 8.34862 4.83105L8.44237 4.99343C8.48767 5.0719 8.46079 5.17224 8.38232 5.21754C8.30385 5.26285 8.20351 5.23596 8.1582 5.15749L8.06445 4.99511Z",
    fill: "#0E2782"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9473,
    y: 3.99609,
    width: 0.421875,
    height: 0.65625,
    rx: 0.210938,
    transform: "rotate(15 13.9473 3.99609)",
    fill: "#0E2782"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.69971,
    y: 4.10547,
    width: 0.421875,
    height: 0.65625,
    rx: 0.210938,
    transform: "rotate(-15 9.69971 4.10547)",
    fill: "#0E2782"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19225 14.9733C7.13111 15.0105 7.05152 14.9928 7.0119 14.9332L3.57787 9.76786C3.37402 9.46125 2.96022 9.37794 2.6536 9.58178C2.34699 9.78562 2.26368 10.1994 2.46752 10.506L5.90155 15.6714C6.33737 16.3269 7.21295 16.5215 7.8854 16.1123L10.3274 14.6261C10.3888 14.5888 10.4688 14.6068 10.5082 14.6669L12.7718 18.1193C13.2038 18.7781 14.0791 18.978 14.7543 18.5719L16.9313 17.2624C16.9903 17.2269 17.0667 17.2422 17.1075 17.2978L18.8381 19.6555C19.056 19.9523 19.4732 20.0163 19.77 19.7984C20.0668 19.5805 20.1308 19.1633 19.913 18.8665L18.1824 16.5088C17.7338 15.8977 16.8936 15.7291 16.244 16.1198L14.067 17.4293C14.0056 17.4662 13.9261 17.4481 13.8868 17.3882L11.6233 13.9359C11.1897 13.2745 10.3098 13.076 9.63425 13.4871L7.19225 14.9733Z",
    fill: "url(#paint0_linear_323_26335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_323_26335",
    x1: 17.6664,
    y1: 16.9664,
    x2: 5.84442,
    y2: 8.26648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/OM.2863f94d2d7d1d1e42f259b5bd2a18e0.svg";
export { ForwardRef as ReactComponent };